import type { IconButtonProps } from '@src/shared/ui/Button';
import { DoubleArrowLeftIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import NavIconButton from './NavIconButton';

const BackwardIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <NavIconButton ref={ref} {...props}>
        <DoubleArrowLeftIcon />
      </NavIconButton>
    );
  },
);

export default BackwardIconButton;
